<template>
    <div class="footer" style="letter-spacing:0.8px">
        <div class="container" style="width:100%">
            <div class="footer_item footer_item1" style="width:30%">
                <!-- <h2>{{$t("footerItem1.title")}}</h2> -->
                <h2 style="margin-bottom:20px"><img  src="../assets/img/csst.png" alt=""></h2>
                <!-- <img  src="../assets/img/csst.png" alt=""> -->
                <p style="line-height: 28px;text-align:left;text-indent:0px;">{{$t("footerItem1.des")}}</p>
                <ul class="footer_contact_list">
                    <h2 style="cursor:pointer;border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px" @mouseover="FaceBook=false" @mouseout="FaceBook=true" ><img v-if="FaceBook"  src="../assets/img/FaceBook.png" alt=""  width=100%><img v-else src="../assets/img/FaceBook1.png" alt=""  width=100%></h2>
                    <!-- <h2 style="border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px"></h2> -->
                    <h2 style="cursor:pointer;border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px;" @mouseover="tuite=false" @mouseout="tuite=true"><img v-if="tuite"  src="../assets/img/tuite.png" alt=""  width=100%><img v-else  src="../assets/img/tuite1.png" alt=""  width=100%></h2>
                    <!-- <h2 style="border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px;"><img  src="../assets/img/tuite1.png" alt=""  width=100%></h2> -->
                    <h2 style="cursor:pointer;border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px" @mouseover="weibo=false" @mouseout="weibo=true"><img v-if="weibo"  src="../assets/img/weibo.png" alt=""  width=100%><img v-else  src="../assets/img/weibo1.png" alt=""  width=100%></h2>
                    <!-- <h2 style="border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px"><img  src="../assets/img/weibo1.png" alt=""  width=100%></h2> -->
                    <h2 style="cursor:pointer;border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px"  @mouseover="weixin=false" @mouseout="weixin=true"><img v-if="weixin"  src="../assets/img/weixin.png" alt=""  width=100%><img v-else  src="../assets/img/weixin1.png" alt=""  width=100%></h2>
                    <!-- <h2 style="border-radius:50%;width:22px;height:22px;text-align:center;margin-right:10px"><img  src="../assets/img/weixin1.png" alt=""  width=100%></h2> -->
                    <!-- <li class="contact_item" style="border-radius:50%;"><router-link to='/'><div class="cent" style="background:#FFDDAB;border-radius:50%;width:22px;height:22px;text-align:center;margin:auto"><i class="iconfont el-icon-iconF"  style="font-size:15px;" ></i></div></router-link></li>
                    <li class="contact_item" style="border-radius:50%;"><router-link to='/'><div class="cent" style="background:#77818E;border-radius:50%;width:22px;height:22px;text-align:center;margin:auto"><i class="iconfont el-icon-iconhuaban2"  style="font-size:15px;" ></i></div></router-link></li>
                    <li class="contact_item" style="border-radius:50%;"><router-link to='/'><div class="cent" style="background:#77818E;border-radius:50%;width:22px;height:22px;text-align:center;margin:auto"><i class="iconfont el-icon-iconweibo"  style="font-size:15px;" ></i></div></router-link></li>
                    <li class="contact_item" style="border-radius:50%;"><router-link to='/'><div class="cent" style="background:#77818E;border-radius:50%;width:22px;height:22px;text-align:center;"><i class="iconfont el-icon-iconweixin"  style="font-size:15px;" ></i></div></router-link></li> -->
                    <!-- <li class="contact_item" style="border-radius:50%;"><router-link to='/'><i class="iconfont icon-mianshulogo" style="color: #FFDDAB"></i></router-link></li> -->
                    <!-- <li class="contact_item"><router-link to='/'><i class="iconfont icon-twitter"></i></router-link></li>
                    <li class="contact_item"><router-link to='/'><i class="iconfont icon-weibo"></i></router-link></li>
                    <li class="contact_item"><router-link to='/'><i class="iconfont icon-weixin"></i></router-link></li> -->
                </ul>
            </div>
            <!-- <div class="footer_item">
                <h2>{{$t("footerItem2.title")}}</h2>
                <ul class="contact_list">
                    <li class="contact_item_detail">
                        <span v-if="chOrEn!='0'">联盟秘书处：</span>
                        <span v-else>Union Secretariat：</span>
                        <span>{{$t("footerItem2.des")}}</span>
                        
                    </li>
                    <li class="contact_item_detail">
                        <i class="iconfont icon-tel"></i>
                        <span>{{$t("footerItem2.phoneNo")}}</span>
                    </li>
                    <li class="contact_item_detail">
                        <i class="iconfont icon-email"></i>
                        <span>{{$t("footerItem2.email")}}</span>
                    </li>
                    <li class="contact_item_detail">
                        <i class="iconfont icon-si-glyph-pin-location-2"></i>
                        <!-- <span v-if="chOrEn!='0'">长春市人民大街9518号</span>
                        <span v-else>9518 Renmin Stress, Changchun P.R.China</span> -->
                        <!-- <span>{{$t("footerItem2.addr")}}</span>
                    </li>
                </ul> -->
            <!-- </div> -->
            <div class="footer_item"  style="width:30%">
                <h2 style="padding-left:5%">{{$t("footerItem3.title")}}</h2>
                <ul class="link_list">
                    <li class="link_item" v-for="(nav,index) in navs" :key="index"><router-link :to="nav.path" exact><span style="text-align:right">{{nav.title}}</span></router-link></li>
                    <!-- <li class="link_item"><router-link to="/sponsor">赞助商</router-link></li>
                    <li class="link_item"><router-link to="/member">会员</router-link></li>
                    <li class="link_item"><router-link to="/meeting">会议</router-link></li>
                    <li class="link_item"><router-link to="/union">联盟</router-link></li>
                    <li class="link_item"><router-link to="/works">作品</router-link></li>
                    <li class="link_item"><router-link to="/company">成员单位</router-link></li> -->
                </ul>
            </div>
            <div class="footer_item" style="width:30%">
                <h2 style="line-height: 30px;padding-top:20px;padding-bottom:20px">{{$t("footerItem4.title")}}</h2>
                <span style="font-size:14px">{{$t("footerItem4.des")}}</span>
            </div>
        </div>
        <div class="copyright">
            <span>Copyright 2020. All rights reversed. Design by goufangbian.com.cn</span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                FaceBook:true,
                tuite:true,
                weibo:true,
                weixin:true,
                chOrEn:sessionStorage.getItem('chOrEn'),
            }
        },
        computed:{
        navs(){
        return [
            { id:1, path:'/home', title:this.$t('footerNav.nav1')},
            { id:2, path:'/forumArticles', title:this.$t('footerNav.nav2')},
            { id:3, path:'/union', title:this.$t('footerNav.nav3')},
            { id:4, path:'/works', title:this.$t('footerNav.nav4')},
            { id:5, path:'/company', title:this.$t('footerNav.nav5')},
            { id:6, path:'/member', title:this.$t('footerNav.nav6')},
            { id:7, path:'/aboutAlliances', title:this.$t('footerNav.nav7')},
            { id:8, path:'/sponsor', title:this.$t('footerNav.nav8')},
            // { id:1, path:'/home', title:this.$t('footerNav.nav1')},
            // { id:2, path:'/union', title:this.$t('footerNav.nav2')},
            // { id:3, path:'/company', title:this.$t('footerNav.nav3')},
            // { id:4, path:'/works', title:this.$t('footerNav.nav4')},
            // { id:5, path:'/forumArticles', title:this.$t('footerNav.nav5')},
            // { id:6, path:'/sponsor', title:this.$t('footerNav.nav6')},
            // { id:7, path:'/aboutAlliances', title:this.$t('footerNav.nav7')},
            // { id:8, path:'/aboutAlliances', title:this.$t('footerNav.nav8')},
        ]
        }},
    }
</script>
<style lang="less" scoped>
    p {
        text-align: justify;
        font-size: 14px;
        text-indent: 28px;
        margin-bottom: 20px;
    }
</style>
<style lang="less" scoped>
.cent{
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer{
    // width: 100%;
    min-width:1440px;
    // height: 500px;
    background: #141D29;
    color: #77818E;
    padding-top: 30px;
    .container{
        padding-left:19%;
        padding-right:19%;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .footer_item{
            // flex:1;
            h2{
                line-height: 80px;
                font-size: 20px;
                // color: #fff;
                letter-spacing: 1px;
            }
            div{
                color: #969696;
                font-size: 14px;
                line-height: 26px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;
            }
            .footer_contact_list{
                margin-top: 27px;
                display: flex;
                .contact_item{
                    padding:0 6px;
                    a{
                        .iconfont{
                        color: #141D29;
                        font-size: 20px;
                        }
                    }
                }
            }
            .contact_list{
                .contact_item_detail{
                    display: flex;
                    align-items: center;
                    line-height: 26px;
                    font-size: 14px;
                    color: #77818E;
                    margin-bottom: 14px;
                    //cursor: pointer;
                    .iconfont{
                        font-size: 20px;
                        // margin-right: 18px;
                    }
                }
                .contact_item_detail:hover{
                    color: #fff;
                }
            }
            .link_list{
                display: flex;
                flex-wrap: wrap;
                .link_item{
                    width: 40%;
                    // line-height: 26px;
                    padding-left:5%;
                    padding-right:5%;
                    margin-bottom: 14px;
                    a{
                        color: #77818E;
                        font-size: 14px;
                    }
                }
                .link_item:hover{
                    a{
                        color: #fff;
                    }
                }
            }
        }
        .footer_item1{
            padding-right: 20px;
        }
    }
    .copyright{
        width: 100%;
        margin:0 auto;
        // border-top:1px solid #969696;
        line-height: 90px;
        text-align: center;
        span{

        }
    }
}
</style>